module.exports = Dexie;